/**
 * Palette dashboard e colori casuali al mount (uno shuffle per chart, stabile in sessione).
 */

/** Palette ufficiale per pie / line / treemap (31 colori). */
export const DASHBOARD_COLOR_PALETTE = Object.freeze([
    '#0F78BE',
    '#0E3178',
    '#7094B8',
    '#C16387',
    '#6B6D8F',
    '#7AA9AE',
    '#A6A6A6',
    '#A5E1F9',
    '#ACBFC4',
    '#215F9A',
    '#28BDE0',
    '#F4D452',
    '#E0286C',
    '#8B4860',
    '#425B61',
    '#3C3C3B',
    '#C9D3F3',
    '#2A93B8',
    '#1A5C74',
    '#E38DAA',
    '#EFDF67',
    '#8BA0E5',
    '#5070D8',
    '#D9D9D9',
    '#163E64',
    '#C1E5F5',
    '#017585',
    '#D1AC0D',
    '#747474',
    '#75BCC2',
    '#0E2841',
])

/** Colore monocolore per tutti i grafici a barre. */
export const BAR_CHART_COLOR = '#28BDED'

const PALETTE_LEN = DASHBOARD_COLOR_PALETTE.length

/** Quanti colori ordinali sorteggiare per grafico (apiNum) nella dashboard. */
const ORDINAL_COUNT_BY_API_NUM = Object.freeze({
    1: 6,
    2: 12,
    3: 4,
    4: 22,
    6: 8,
    7: 6,
    8: 15,
    9: 14,
    10: 12,
    11: 7,
    12: 8,
    13: 4,
    14: 10,
})

/**
 * @param {number} apiNum
 * @returns {number}
 */
export function getOrdinalColorCountForDashboardApi(apiNum) {
    const c = ORDINAL_COUNT_BY_API_NUM[Number(apiNum)]
    return c !== undefined ? c : 10
}

/**
 * Restituisce `count` colori pseudocasuali dalla palette (shuffle, con ciclo se count > palette).
 * @param {number} count
 * @returns {string[]}
 */
export function getRandomColors(count) {
    const n = Math.max(Number(count) || 0, 1)
    const shuffled = [...DASHBOARD_COLOR_PALETTE].sort(() => Math.random() - 0.5)
    return Array.from({ length: n }, (_, i) => shuffled[i % PALETTE_LEN])
}

/**
 * ColorMap ECharts per il tipo grafico scelto.
 * I colori ordinali sono quelli assegnati al chart al reload (non rigenerati al cambio tipo).
 *
 * @param {string} chartType
 * @param {string[]} mapGradientColors - gradiente mappa (non randomizzato)
 * @param {string[]} ordinalColors - colori assegnati al chart al mount
 */
export function getDashboardColorMapForChartType(chartType, mapGradientColors, ordinalColors) {
    if (chartType === 'map') {
        return {
            type: 'visualMap',
            visualMin: 0,
            visualMax: 100,
            inRange: {
                color: [...mapGradientColors],
            },
        }
    }
    if (chartType === 'bar') {
        return {
            type: 'ordinal',
            colors: [BAR_CHART_COLOR],
        }
    }
    const colors =
        Array.isArray(ordinalColors) && ordinalColors.length > 0
            ? ordinalColors
            : getRandomColors(10)
    return {
        type: 'ordinal',
        colors: [...colors],
    }
}

/**
 * Assegna ordinalColors e colorMap iniziali per un chart dashboard.
 *
 * @param {number} apiNum
 * @param {string} chartType
 * @param {string[]} mapGradientColors
 */
export function createDashboardChartColorState(apiNum, chartType, mapGradientColors) {
    const ordinalColors = getRandomColors(getOrdinalColorCountForDashboardApi(apiNum))
    return {
        ordinalColors,
        colorMap: getDashboardColorMapForChartType(chartType, mapGradientColors, ordinalColors),
    }
}
